/* global width:true */
/* eslint no-undef: "error" */

import React from "react";
import { SocialShare, StoryElement, WithLazy } from "@quintype/components";
import { object, array, string, func } from "prop-types";
import assetify from "@quintype/framework/assetify";

// import MetypeCommentWrapper from "../../metype-comments";
import StoryMetaInfo from "../../molecules/story-meta-info";
import Demarcation from "../../atoms/demarcation";
import StickySocialShareTemplate from "../../molecules/sticky-social-share";
import StoryTag from "../story-tag";
import SideBar from "../side-bar";
import RelatedStories from "../related-stories";
import signsMapping from "../utils";
import CardShareTemplate from "../live-blog/card-share";
import { storyShareClickHandler } from "../../utils";
import DfpAd from "../../dfp-ad";

import "./horoscope.m.css";

class HoroscopeStoryTemplate extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      renderMetype: false,
      showReadmore: {},
      wrapperClass: "",
      addReadmore: false,
      width: null
    };
    this.toggleReadmore = this.toggleReadmore.bind(this);
  }

  toggleReadmore() {
    this.setState({ wrapperClass: "content-wrapper", addReadmore: false });
  }

  isWidthPresent = () => {
    this.setState({ width });
  };

  componentDidMount() {
    this.isWidthPresent();

    const { cardId } = this.props;
    if (cardId) {
      setTimeout(function() {
        document.getElementById(cardId) &&
          document.getElementById(cardId).scrollIntoView({
            behavior: "smooth",
            block: "start",
            inline: "nearest"
          });
      }, 1000);
    }

    this.setState({
      renderMetype: true
    });
  }

  render() {
    const { story, trendingStories, recentStories, collectionName, config } = this.props;
    const publisherUrl = config["sketches-host"] || "https://www.freepressjournal.in";

    const renderStoryCards = storyCards => {
      const cards = storyCards.slice(0, 12);
      return cards.map((card, index) => {
        const getFirstTextCardElement = card["story-elements"].filter(element => element.type === "text").slice(0, 1);
        return (
          <div styleName="zodiac-card" id={card.id} key={index}>
            <div>
              <WithLazy margin="50px">
                {() => <img src={` ${assetify(signsMapping[index]["logo"])}`} alt="Logo" />}
              </WithLazy>
            </div>
            <div>
              <div styleName="zodiac-card-header">
                <p styleName="zodiac-sign-name">{signsMapping[index]["title"]}</p>
                <SocialShare
                  template={CardShareTemplate}
                  title={card.metadata["social-share"].title || story.headline}
                  url={encodeURIComponent(story && story.slug + "?cardId=" + card.id)}
                  color="#333"
                  className={"card-share"}
                />
              </div>
              <StoryElement story={story} element={getFirstTextCardElement[0]} externalLink={true} />
            </div>
          </div>
        );
      });
    };

    return (
      <React.Fragment>
        <div styleName="wrapper">
          <div>
            <StoryMetaInfo story={story} />
            <div styleName="card-image">
              {this.state.width <= 992 && (
                <div styleName="dfp-728x90">
                  {/* <Adsense adSlotId="3689255812" width="300" height="250" /> */}
                  <DfpAd adtype="FPJ_ROS_Mobile_Middle_300x250" />
                </div>
              )}
              {this.state.width >= 992 && (
                <div styleName="dfp-728x90">
                  {/* <Adsense adSlotId="5135370519" width="720" height="90" /> */}
                  <DfpAd adtype="FPJ_ROS_Middle_728x90" />
                </div>
              )}
            </div>
            <div styleName="story-content">
              <div>
                <SocialShare
                  template={StickySocialShareTemplate}
                  title={story.headline}
                  url={story.slug}
                  color="#000"
                  sticky
                  onClick={storyShareClickHandler(story["story-content-id"], `${publisherUrl}/${story.slug}`)}
                />
              </div>
              <div styleName="horoscope-story-content">
                <div ref={divElement => (this.divElement = divElement)}>
                  <div styleName={this.state.wrapperClass}>
                    {renderStoryCards(story.cards)}

                    {this.state.width > 992 && (
                      <div styleName="dfp-728x90">
                        {/* <Adsense adSlotId="5135370519" width="720" height="90" /> */}
                        <DfpAd adtype="FPJ_ROS_Middle_1_728x90" />
                      </div>
                    )}
                    {this.state.width <= 992 && (
                      <div styleName="dfp-728x90">
                        <DfpAd adtype="FPJ_ROS_Mobile_Middle_1_300x250" />
                        {/* <Adsense adSlotId="5135370519" width="720" height="90" /> */}
                      </div>
                    )}

                    <StoryTag tags={story.tags} />
                    {/* {this.state.renderMetype && <MetypeCommentWrapper story={story} />} */}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div>
            <SideBar stories={recentStories} collectionName={collectionName} id={story.id} />
          </div>
        </div>
        <div styleName="related-stories">
          <RelatedStories relatedStories={trendingStories} collectionName="trending" />
          <div id={`${story.slug}`} />
        </div>
      </React.Fragment>
    );
  }
}

function HoroscopeStory(props) {
  return (
    <div className="story-grid">
      <HoroscopeStoryTemplate
        story={props.story}
        cardId={props.cardId}
        trendingStories={props.trendingStories}
        collectionName={props.collectionName}
        recentStories={props.recentStories}
        config={props.config}
      />
      <Demarcation />
    </div>
  );
}

HoroscopeStoryTemplate.propTypes = {
  story: object,
  trendingStories: array,
  collectionName: string,
  cardId: string,
  recentStories: array,
  config: func
};

HoroscopeStory.propTypes = {
  story: object,
  trendingStories: array,
  collectionName: string,
  cardId: string,
  recentStories: array,
  config: func
};

export default HoroscopeStory;
